import { useLocation } from 'react-router-dom';
import { getModuleSelectedGroup } from './navigationPath';

function useModuleSelected() {
  const { pathname } = useLocation();
  return getModuleSelectedGroup(pathname);
}

export default useModuleSelected;
